<template>
  <div class="left_menu">
    <img src="../../../static/img/leftNav-news.png" alt />
    <div v-for="(nav, i) in navList" :key="i">
      <ul>
        <template v-if="fId == nav.catid">
          <li v-for="(menu, index) in nav.level2" :key="index">
            <a
              href="javascript:;"
              @click="subnavClick(nav.catid, nav.catname, menu.catid, menu.catname)"
            >{{menu.catname}}</a>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
var that;
export default {
  data() {
    return {
      fId: "",
      //左侧导航栏
      leftNav: [],
      navList: []
      // leftNav: [
      //   {
      //     fId: 1,
      //     id: 14,
      //     name: "今日衡中",
      //     catname: "学校概况"
      //   },
      //   {
      //     fId: 1,
      //     id: 15,
      //     name: "今日衡中",
      //     catname: "校园新闻"
      //   },
      //   {
      //     fId: 1,
      //     id: 17,
      //     name: "今日衡中",
      //     catname: "媒体报道"
      //   },
      //   {
      //     fId: 1,
      //     id: 16,
      //     name: "今日衡中",
      //     catname: "公告通知"
      //   }
      // ]
    };
  },
  mounted() {
    that = this;
    that.fId = that.$route.query.fId;
    console.log(that.fId)
    that.init();
  },
  methods: {
    init() {
      $.ajax({
        type: "get",
        url: url + "/category",
        success: function(data) {
          if (data.code == "0") {
            console.log(data.data);
            // for (var i = 0; i < data.data.length; i++) {
            //   if (that.fId == data.data[i].catid) {
            //     that.leftNav = data.data[i].level2;
            //   }
            // }
            that.navList = data.data;
          }
        },
        error(data) {
          alert(data.msg);
        }
      });
    },
    // 左侧导航跳转事件
    subnavClick(fId, fName, id, secondName) {
      //学校概况
      if (id == 14) {
        this.$router.push({
          path: "list",
          query: {
            fId: fId,
            name: fName,
            id: id,
            secondName: secondName
          }
        });
      } else {
        this.$router.push({
          path: "leftNavList",
          query: {
            fId: fId,
            name: fName,
            id: id,
            secondName: secondName
          }
        });
      }
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/com/leftNav.vue